import React from 'react';
import { styled } from '@mui/material/styles';
import { Divider } from '@mui/material';
import { MoreHorizOutlined } from '@mui/icons-material';

const StyledDiv = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 3),
  color: theme.palette.grey[700],
}));
const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(0.5, 2, 1, 2),
}));

interface IProps {
  showDivider?: boolean;
}

export const Ellipsis = ({ showDivider }: IProps) => {
  return (
    <>
      <StyledDiv>
        <MoreHorizOutlined />
      </StyledDiv>
      {showDivider && <StyledDivider variant={'middle'} />}
    </>
  );
};
